import { render, staticRenderFns } from "./CreatePoint.vue?vue&type=template&id=7e24f544&scoped=true"
import script from "./CreatePoint.vue?vue&type=script&lang=js"
export * from "./CreatePoint.vue?vue&type=script&lang=js"
import style0 from "./CreatePoint.vue?vue&type=style&index=0&id=7e24f544&prod&scoped=true&lang=css"
import style1 from "./CreatePoint.vue?vue&type=style&index=1&id=7e24f544&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e24f544",
  null
  
)

export default component.exports